(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.hotel.pdf.view
  (:require
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.card.pdf.view :as card]
   [frontend.ui.component.lp-portal.column.pdf.view :as column]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.component.lp-portal.big-figure.pdf.view :as big-figures]
   [frontend.ui.component.lp-portal.report.body.real-estate.pdf.view.esg :as re-esg]
   [frontend.ui.component.lp-portal.report.body.real-estate.pdf.view.tearsheet :as re-tearsheet]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.style.theme.core :as theme]))

(defn- recent-development-page
  [report-data]
  (page/page
   (page/third-column-background)
   (page/page-title {:fund-name (:fund-name report-data) :page-title "Overview" :toc-item true})
   (column/columns-2-to-1
    (card/card
     "Recent development"
     (text-content/rich-content (-> report-data
                                    :overview
                                    :recent-development-text
                                    :rich-content)))
    (card/card
     nil
     (big-figures/table (-> report-data
                            :overview
                            :overview-figures
                            :figures)
                        1)
     (text-content/optional-footer (-> report-data
                                       :overview
                                       :overview-figures))))))

(defn- charts-page-1
  [report-data]
  (page/page
   (page/page-title {:fund-name (:fund-name report-data) :page-title "Overview"})
   {:stack
    [(column/columns
      (card/card
       "NAV development"
       {:svg       (chart-view/chart-svg "highcharts"
                                         (-> report-data
                                             :overview
                                             :net-development
                                             :figures))
        :width     400
        :alignment :center}
       (text-content/optional-footer (-> report-data
                                         :overview
                                         :net-development)))
      (card/card
       "Fund NAV change breakdown"
       {:svg       (chart-view/chart-svg "highcharts"
                                         (-> report-data
                                             :overview
                                             :fund-nav-change-breakdown
                                             :figures))
        :width     400
        :alignment :center}
       (text-content/optional-footer (-> report-data
                                         :overview
                                         :fund-nav-change-breakdown))))]}))


(defn- charts-page-2
  [report-data]
  [(page/page
    (page/page-title {:fund-name (:fund-name report-data) :page-title "Overview"})
    {:stack
     (let [height 225]
       [(column/columns
         (card/card
          "Market value by operator, M€"
          {:svg       (chart-view/chart-svg "highcharts"
                                            (-> report-data
                                                :overview
                                                :portfolio-at-market-value
                                                :figures))
           :width     350
           :height    height
           :alignment :center}
          (text-content/optional-footer (-> report-data
                                            :overview
                                            :portfolio-at-market-value)))
         (card/card
          "GAV breakdown, M€"
          {:svg       (chart-view/chart-svg "highcharts"
                                            (-> report-data
                                                :overview
                                                :gav-breakdown
                                                :figures))
           :width     350
           :height    height
           :alignment :center}
          (text-content/optional-footer (-> report-data
                                            :overview
                                            :gav-breakdown))))])})
   (page/page
    (page/page-title {:fund-name (:fund-name report-data) :page-title "Overview"})
    {:stack
     (let [height 225]
       [(column/columns
         (card/card
          "Market value by location, M€"
          {:svg       (chart-view/chart-svg "highcharts"
                                            (-> report-data
                                                :overview
                                                :market-value-by-location
                                                :figures))
           :width     350
           :height    height
           :alignment :center}
          (text-content/optional-footer (-> report-data
                                            :overview
                                            :market-value-by-location)))
         (card/card
          "Market value by currency, M€"
          {:svg       (chart-view/chart-svg "highcharts"
                                            (-> report-data
                                                :overview
                                                :market-value-by-currency
                                                :figures))
           :width     350
           :height    height
           :alignment :center}
          (text-content/optional-footer (-> report-data
                                            :overview
                                            :market-value-by-currency))))])})])

(defn overview-pages
  [report-data]
  (concat [(recent-development-page report-data)]
          (table/dynamic-table-pages {:fund-name (:fund-name report-data) :page-title "Overview"}
                                     "Fund figures (INREV)"
                                     (-> report-data
                                         :overview
                                         :recent-development)
                                     {:odd-color     (theme/color [:pdf :table :odd-color])
                                      :even-color    (theme/color [:pdf :table :even-color])
                                      :heading-color (theme/color [:pdf :table
                                                                   :heading-color])})
          [(charts-page-1 report-data)]
          (table/dynamic-table-pages {:fund-name (:fund-name report-data) :page-title "Overview"}
                                     "Total return on a time-weighted basis"
                                     (-> report-data
                                         :overview
                                         :total-return)
                                     {:odd-color     (theme/color [:pdf :table :odd-color])
                                      :even-color    (theme/color [:pdf :table :even-color])
                                      :heading-color (theme/color [:pdf :table
                                                                   :heading-color])})
          (charts-page-2 report-data)))

(defn debt-financing-pages
  [report-data]
  (let [page-title (str (:fund-name report-data) " - Debt financing")]
    (concat
     [(page/page
       (page/page-title
        {:fund-name (:fund-name report-data) :page-title "Debt financing" :toc-item true})
       (column/columns
        (card/card
         "Description"
         (text-content/rich-content (-> report-data
                                        :debt-financing
                                        :debt-financing-text
                                        :rich-content)))
        (column/column
         (table/dynamic-table-card "Debt Key Figures"
                                   (-> report-data
                                       :debt-financing
                                       :debt-key-figures)
                                   {:full-width?   true
                                    :odd-color     (theme/color [:pdf :table :odd-color])
                                    :even-color    (theme/color [:pdf :table :even-color])
                                    :heading-color (theme/color [:pdf :table
                                                                 :heading-color])}))))]
     (table/dynamic-table-pages {:fund-name (:fund-name report-data) :page-title "Debt financing"}
                                "Debt financing, €"
                                (-> report-data
                                    :debt-financing
                                    :portfolio-debt-financing)
                                {:odd-color     (theme/color [:pdf :table :odd-color])
                                 :even-color    (theme/color [:pdf :table :even-color])
                                 :heading-color (theme/color [:pdf :table
                                                              :heading-color])})
     [(page/page
       (page/page-title {:fund-name (:fund-name report-data) :page-title "Debt financing"})
       (column/columns
        (column/column
         (card/card "Lender by loan commitment, M€"
                    {:svg   (chart-view/chart-svg "highcharts"
                                                  (-> report-data
                                                      :debt-financing
                                                      :lender-by-loan-commitment
                                                      :figures))
                     :width 350}
                    (text-content/optional-footer (-> report-data
                                                      :debt-financing
                                                      :lender-by-loan-commitment))))
        (column/column
         (card/card "Lender by loans outstanding, M€"
     
                    {:svg   (chart-view/chart-svg "highcharts"
                                                  (-> report-data
                                                      :debt-financing
                                                      :lender-by-loans-outstanding
                                                      :figures))
                     :width 350}
                    (text-content/optional-footer (-> report-data
                                                      :debt-financing
                                                      :lender-by-loans-outstanding))))))])))

(defn details-and-figures-pages
  [report-data]
  (let [page-title {:fund-name  (:fund-name report-data)
                    :page-title "Details and figures"}]
    (concat
     (table/dynamic-table-pages
      {:fund-name (:fund-name report-data) :page-title "Details and figures" :toc-item true}
      "Current portfolio, €"
      (-> report-data
          :details-and-figures
          :current-portfolio)
      {:wrap-text-after 6
       :odd-color       (theme/color [:pdf :table :odd-color])
       :even-color      (theme/color [:pdf :table :even-color])
       :heading-color   (theme/color [:pdf :table
                                      :heading-color])})
     (table/dynamic-table-pages page-title
                                "Exited portfolio, €"
                                (-> report-data
                                    :details-and-figures
                                    :exited-portfolio)
                                {:wrap-text-after 6
                                 :odd-color       (theme/color [:pdf :table :odd-color])
                                 :even-color      (theme/color [:pdf :table :even-color])
                                 :heading-color   (theme/color [:pdf :table
                                                                :heading-color])})
     (table/dynamic-table-pages page-title
                                "Investment summary, €"
                                (-> report-data
                                    :details-and-figures
                                    :investment-summary)
                                {:full-width?    true
                                 :hidden-columns #{"IQID"}
                                 :odd-color      (theme/color [:pdf :table :odd-color])
                                 :even-color     (theme/color [:pdf :table :even-color])
                                 :heading-color  (theme/color [:pdf :table
                                                               :heading-color])})
     (table/dynamic-table-pages page-title
                                "NAV breakdown, €"
                                (-> report-data
                                    :details-and-figures
                                    :nav-breakdown)
                                {:wrap-text-after 6
                                 `:odd-color      (theme/color [:pdf :table :odd-color])
                                 :even-color      (theme/color [:pdf :table :even-color])
                                 :heading-color   (theme/color [:pdf :table
                                                                :heading-color])})
     (table/dynamic-table-pages page-title
                                "NAV BREAKDOWN (INREV), €"
                                (-> report-data
                                    :details-and-figures
                                    :inrev-nav)
                                {:odd-color     (theme/color [:pdf :table :odd-color])
                                 :even-color    (theme/color [:pdf :table :even-color])
                                 :heading-color (theme/color [:pdf :table
                                                              :heading-color])}))))

(defn financial-statements-pages
  [report-data]
  (let [{:keys [group-income-statement statement-of-financial-position cash-flow-statement]}
        (:financial-statements report-data)]
    (concat
     (table/dynamic-table-pages
      {:fund-name (:fund-name report-data) :page-title "Financial statements" :toc-item true}
      "Consolidated statement of comprehensive income (INREV), €"
      group-income-statement
      {:odd-color     (theme/color [:pdf :table :odd-color])
       :even-color    (theme/color [:pdf :table :even-color])
       :heading-color (theme/color [:pdf :table
                                    :heading-color])})
     (table/dynamic-table-pages {:fund-name  (:fund-name report-data)
                                 :page-title "Financial statements"}
                                "Consolidated statement of financial position (INREV), €"
                                statement-of-financial-position
                                {:odd-color     (theme/color [:pdf :table :odd-color])
                                 :even-color    (theme/color [:pdf :table :even-color])
                                 :heading-color (theme/color [:pdf :table
                                                              :heading-color])})
     (table/dynamic-table-pages {:fund-name  (:fund-name report-data)
                                 :page-title "Financial statements"}
                                "Consolidated statement of cash flows (INREV), €"
                                cash-flow-statement
                                {:odd-color     (theme/color [:pdf :table :odd-color])
                                 :even-color    (theme/color [:pdf :table :even-color])
                                 :heading-color (theme/color [:pdf :table
                                                              :heading-color])}))))

(defn hotel-pages
  [{:keys [tearsheet overview esg debt-financing details-and-figures financial-statements]
    :as   report-data}]
  (concat
   [(page/toc-page {:cover-image :front-page-image
                    :report-data report-data})]
   [(re-tearsheet/tearsheet-page report-data)]
   (overview-pages report-data)
   (debt-financing-pages report-data)
   (re-esg/esg-pages report-data)
   (details-and-figures-pages report-data)
   (financial-statements-pages report-data)))
